export default __webpack_public_path__ + "static/media/logoOfSign.58c8ed9d.png";